import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { DUPLICATE_PT5_MESSAGE } from "../utils/propertyErrors";

export default function DuplicatePt5Modal({
  isOpen,
  onClose,
  onSave,
  submitting = false,
}) {
  const [newPt5, setNewPt5] = useState("");

  useEffect(() => {
    if (isOpen) {
      setNewPt5("");
    }
  }, [isOpen]);

  const handleSave = () => {
    const trimmed = newPt5.trim();
    if (!trimmed || submitting) return;
    onSave(trimmed);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-[70] p-4"
        >
          <motion.div
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.9 }}
            className="bg-white p-6 rounded-xl w-full max-w-md shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold mb-3 text-gray-900">
              Duplicate PT-5 Number
            </h2>
            <p className="text-gray-700 mb-4">{DUPLICATE_PT5_MESSAGE}</p>

            <label className="block text-sm font-medium text-gray-700 mb-1">
              Enter new PT-5 number
            </label>
            <input
              type="text"
              value={newPt5}
              onChange={(e) => setNewPt5(e.target.value)}
              placeholder="PT-5 Serial Number"
              className="w-full p-3 border border-gray-300 rounded-lg mb-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSave();
              }}
            />

            {!newPt5.trim() && (
              <p className="text-red-500 text-sm mb-3">
                Please enter a new PT-5 number
              </p>
            )}

            <div className="flex gap-3 mt-4">
              <button
                type="button"
                onClick={handleSave}
                disabled={!newPt5.trim() || submitting}
                className={`flex-1 px-4 py-2 rounded-lg text-white font-medium transition ${
                  newPt5.trim() && !submitting
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
              >
                {submitting ? "Saving..." : "Save"}
              </button>
              <button
                type="button"
                onClick={onClose}
                disabled={submitting}
                className="flex-1 px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg font-medium transition disabled:opacity-60"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
